export default __webpack_public_path__ + "static/media/sharestoria.f4fbe99c.png";